import { render, staticRenderFns } from "./registerXy.vue?vue&type=template&id=1a070cdf&scoped=true"
import script from "./registerXy.vue?vue&type=script&lang=js"
export * from "./registerXy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a070cdf",
  null
  
)

export default component.exports